export class SigortaSirket {
    tramerKodu: any;
    adi: any;
}
